
@switch (channel?.deliveryMethod) {
  @case ('EMAIL') {
    <div class="fdx-u-font-size--larger fdx-o-grid__row">
      <ciam-icon class="fdx-c-icon fdx-u-align--center fdx-u-color--blue fdx-u-flex--center fdx-u-font-size--h4 fdx-u-mr--4" aria-hidden="true" key="communication_devices_mail" color="#007ab7"></ciam-icon>
      <dl class=" fdx-c-definitionlist  fdx-c-definitionlist--default fdx-o-grid__item">
        <dt id="sms-btn" class="fdx-c-definitionlist__title fdx-u-font-size--small fdx-u-align--left">
          {{'twoStepVerification.email' | translate}}
        </dt>
        @if (channel?.value) {
          <dd id="smsResponse" class="fdx-c-definitionlist__description fdx-u-font-size--small fdx-u-align--left">
            {{channel?.value | maskValue}}
          </dd>
        }
      </dl>
    </div>
  }
  @case ('SMS') {
    <div class="fdx-u-font-size--larger fdx-o-grid__row">
      <ciam-icon class="fdx-c-icon fdx-u-align--center fdx-u-color--blue fdx-u-flex--center fdx-u-font-size--h4 fdx-u-mr--4" aria-hidden="true" key="communication_devices_mobile" color="#007ab7"></ciam-icon>
      <dl class=" fdx-c-definitionlist  fdx-c-definitionlist--default fdx-o-grid__item">
        <dt id="sms-btn" class="fdx-c-definitionlist__title fdx-u-font-size--small fdx-u-align--left">
          {{'twoStepVerification.textMessage' | translate}}
        </dt>
        @if (channel?.value) {
          <dd id="smsResponse" class="fdx-c-definitionlist__description fdx-u-font-size--small fdx-u-align--left">
            {{channel?.value  | maskValue}}
          </dd>
        }
        <p class="fdx-c-form-group__message fdx-c-paragraph fdx-o-grid__item--10@large fdx-u-mb--0"
          aria-atomic="true" aria-live="assertive">
          <span aria-atomic="true" id='termsAndConditions_id' aria-live="assertive"
            (click)="termsAndConditionClick($event)" (keydown.enter)="termsAndConditionClick($event)"
            [innerHTML]="'twoStepVerification.termsAndConditions' | translate">
          </span>
        </p>
      </dl>
    </div>
  }
  @case ('CALL') {
    <div class="fdx-u-font-size--larger fdx-o-grid__row">
      <ciam-icon class="fdx-c-icon fdx-u-align--center fdx-u-color--blue fdx-u-flex--center fdx-u-font-size--h4 fdx-u-mr--4" aria-hidden="true" key="communication_devices_phone" color="#007ab7"></ciam-icon>
      <dl class=" fdx-c-definitionlist  fdx-c-definitionlist--default fdx-o-grid__item">
        <dt id="sms-btn" class="fdx-c-definitionlist__title fdx-u-font-size--small fdx-u-align--left">
          {{'twoStepVerification.phoneCall' | translate}}
        </dt>
        @if (channel?.value) {
          <dd id="smsResponse" class="fdx-c-definitionlist__description fdx-u-font-size--small fdx-u-align--left">
            {{channel?.value  | maskValue}}
          </dd>
        }
      </dl>
    </div>
  }
}
